export default "__VITE_ASSET__BriN09Wd__ 300w";